// import {rootPath as ExhibidoresRootPath, rootName as ExhibidoresRootName} from '../views/Easylunch/Exhibidores/Headers/router'
import {rootPath as CocinaeasylunchRootPath, rootName as CocinaeasylunchRootName, router as CocinaeasylunchRouter, mainComponent as CocinaeasylunchMainComponent} from '../views/Cocinaeasylunch/router'

const rootPath = '/easylunch',
    rootName = 'Easylunch - ',
    parentsName = 'Padres',
    cedes = 'Escuelas / Empresas',
    lunchBoxesName = 'Loncheras',
    dateblockerName = 'Bloqueo de fechas',
    agendasEscolares = 'Agenda';

const router = {
    path: rootPath,
    redirect: rootPath + '/general',
    component: () => import('@/containers/DefaultContainer'),
    children: [
        // CocinaeasylunchRouter,
        {
            path: CocinaeasylunchRouter.path,
            name: rootName + CocinaeasylunchRootName,
            meta: CocinaeasylunchRouter.meta,
            component: CocinaeasylunchMainComponent
        },
        {
            path: 'padres',
            name: rootName + parentsName,
            component: () => import('@/views/Easylunch/Presencias.vue'),
            meta: {
                tipo: 'directo'
            }
        },
        {
            path: 'loncheras',
            name: rootName + lunchBoxesName,
            component: () => import('@/views/Easylunch/Presencias.vue'),
            meta: {
                tipo: 'alumno'
            }
        },
        {
            path: 'agenda',
            name: rootName + agendasEscolares,
            component: () => import('@/views/Easylunch/Agenda.vue')
        },
        {
            path: 'sedes',
            name: rootName + cedes,
            component: () => import('@/views/Easylunch/Cedes.vue')
        },
        {
            path: 'date-blocker',
            name: rootName + dateblockerName,
            component: () => import('@/views/Easylunch/DateBlockers.vue')
        }
    ]
}

// EASYLUNCH
const nav = {
    name: 'EASYLUNCH',
    icon: 'icon icon-easylunch',
    url: rootPath,
    children: [
        {
            name: CocinaeasylunchRootName,
            url: CocinaeasylunchRootPath
        },
        {
            name: parentsName,
            url: rootPath + '/padres'
        },
        {
            name: lunchBoxesName,
            url: rootPath + '/loncheras'
        },
        {
            name: agendasEscolares,
            url: rootPath + '/agenda'
        },
        {
            name: cedes,
            url: rootPath + '/sedes'
        },
        // {
        //     name: ExhibidoresRootName,
        //     url: ExhibidoresRootPath
        // }
    ]
}

export {
    rootPath,
    dateblockerName,
    cedes,
    parentsName,
    router,
    nav
}